<template>
  <button style="display:none;" type="button" class="btn btn-primary" data-bs-toggle="modal"
                                data-bs-target="#mdlSelectUser" id="btnOpenMdlSelectUser">Open</button>
  <div class="modal fade" id="mdlSelectUser" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Log in to continue</h5>
          <button type="button" id="btnCloseMdlSelectUser" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              To save, or accept this quote, please sign in or enter your details
            </div>
          </div>

          <div v-if="!viewLogin">
            <div class="row mt-3">
              <div class="col-sm-1"></div>
              <div class="col-sm-10">
                <newClient @registered="gotUser($event)" @notregister="viewLogin = true"></newClient>
              </div>
              <div class="col-sm-1"></div>
            </div>
          </div>

          <div v-if="viewLogin">
            <div class="row mt-3">
              <div class="col-sm-1"></div>
              <div class="col-sm-10">
                <logIn @logged="gotUser($event)" @notclient="viewLogin = false"></logIn>
              </div>
              <div class="col-sm-1"></div>
            </div>
          </div>
          <div class="row mt-5"></div>
        </div>
      </div>
    </div>
  </div>

  <forgot_client />

</template>
    
<script>
import newClient from "./new-client.vue";
import logIn from "./log-in.vue";
import forgot_client from "../../components/global/forgot-client.vue"

export default {

  components: { newClient, logIn,'forgot_client':forgot_client },
  emits: ['saved'],
  data: function () {
    return {
      idClient: 0,
      viewLogin: true
    }

  },
  mounted() {
  },
  methods: {
    gotUser(user) {
      this.idClient = user.idClient;
      this.$emit('saved', this.idClient)
    }
  },

}
</script>
    
    